var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../Icon/Icon';
import IconButton from './IconButton';
import Tooltip from '../Tooltip';
import LayoutStore from '../../../flux/stores/LayoutStore';
const ExpandableIconButton = (props) => {
    const { IconProps, general, expanded } = props, rest = __rest(props, ["IconProps", "general", "expanded"]);
    const layoutResources = LayoutStore.getResourcesLayout();
    let text = '';
    if (layoutResources) {
        text = expanded ? (general ? layoutResources.lblCollapseAll : layoutResources.lblCollapse)
            : (general ? layoutResources.lblExpandAll : layoutResources.lblExpand);
    }
    return (React.createElement(Tooltip, { title: text },
        React.createElement(IconButton, Object.assign({ "aria-label": text, color: "gray" }, rest),
            React.createElement(Icon, Object.assign({ name: expanded ? 'chevron-up' : 'chevron-down' }, IconProps)))));
};
export default ExpandableIconButton;
